import { markDeliveryRetrievedInMock } from './deliveryDetail';

// Mock of the retrieve WRITE: simulate latency, then flip the delivery to retrieved in the shared
// detail mock, so a follow-up fetchDeliveryDetailMock returns the new state. Idempotent. No
// error-injection hook, unlike its siblings': error-path component tests inject a failing fn
// directly via DI; add one only when a dev flow needs it.
export async function retrieveDeliveryMock(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  markDeliveryRetrievedInMock(id);
}
